import {
  AppBar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Hidden,
  Input,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Container,
} from "@material-ui/core";
// import PropTypes from 'prop-types';
import { withStyles } from "@material-ui/core/styles";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Search from "@material-ui/icons/Search";
import classnames from "classnames";
import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { HashLink as AnchorLink } from "react-router-hash-link";
import { Scrollchor } from "react-scrollchor";
import Slider from "react-slick";
import { REQUEST_FOR_CALLBACK_DEPOSIT_PAGE } from "routes/paths";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ACTIONS, eventTracker, LABELS } from "utils/analytics";
import { ewbConfig } from "../config";
import { RenderFabButton } from "./Navigation";

//const useStyles = makeStyles((theme) => ({
const styles = (theme) => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  cardPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(3),
  }),
  subheadline: {
    margin: "15px auto",
    [theme.breakpoints.up("md")]: {
      margin: "15px",
    },
  },
  bottomMargin: {
    marginBottom: 20,
  },
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },
  promoButton: {
    width: "100%",
    marginBottom: "10px",
  },
  modalButtonStyling: {
    textTransform: "inherit",
    fontWeight: "unset",
    padding: "0",
    lineHeight: "unset",
    display: "contents",
  },
  borderZero: {
    "& > div:last-child  ": {
      border: "none",
    },
  },
  benefitBorder: {
    padding: "16px 25px",
    borderRight: "2px solid #ddd",
    [theme.breakpoints.down("sm")]: {
      borderRight: "none",
    },
  },

  serviceBorder: {
    paddingLeft: "25px!important",
    borderRight: "2px solid #ddd",
    [theme.breakpoints.down("sm")]: {
      borderRight: "none",
    },
  },

  buttonBottom: {
    marginTop: "10px",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: "5px",
    },
  },
  rounderNumber: {
    backgroundColor: theme.palette.secondary.main,
    width: "40px",
    height: "35px",
    borderRadius: "30px",
    margin: "15px auto",
    color: "#fff",
    paddingTop: "3px",
  },
  whiteText: {
    color: "#fff",
  },
  applySteps: {
    "& div:last-child > img ": {
      display: "none",
    },
  },
  rounderBorder: {
    borderRadius: "8px",
  },
  listPadding: {
    paddingTop: 0,
    listStyleType: "disc",
  },
  formControl: {
    position: "relative",
    top: "7px",
  },
  cardHeight: {
    minHeight: "140px",
    [theme.breakpoints.only("xs")]: {
      minHeight: "auto",
    },
    [theme.breakpoints.only("md")]: {
      minHeight: "195px",
    },
  },
  homeCardHeight: {
    minHeight: "110px",
    [theme.breakpoints.only("xs")]: {
      minHeight: "auto",
    },
    [theme.breakpoints.only("md")]: {
      minHeight: "135px",
    },
  },
  feesFirst: {
    backgroundColor: "#c6d147",
    width: "35%",
  },
  feesLast: {
    border: "solid 1px #d6d6d6",
  },
  // slider
  carouselStyling: {
    height: "370px",
    display: "flex!important",
    [theme.breakpoints.only("md")]: {
      width: "98%!important",
    },
    [theme.breakpoints.down("md")]: {
      position: "relative",
    },
    [theme.breakpoints.up("lg")]: {
      "& section": {
        paddingRight: "30px",
      },
    },
    "& > div:first-child": {
      backgroundColor: "#c6d147",
      [theme.breakpoints.down("md")]: {
        backgroundColor: "rgba(198, 209, 71, 0.7)",
        position: "absolute",
        height: "370px",
      },
    },
  },
  carouselStylingExplore: {
    height: "230px",
    display: "flex!important",
    [theme.breakpoints.only("md")]: {
      width: "100%!important",
    },
    [theme.breakpoints.down("md")]: {
      position: "relative",
    },
    [theme.breakpoints.up("lg")]: {
      "& section": {
        paddingRight: "30px",
      },
    },
    "& > div:first-child": {
      backgroundColor: "#c5c5c5",
      [theme.breakpoints.down("md")]: {
        backgroundColor: "#c5c5c5",
        position: "absolute",
        height: "100%",
      },
    },
  },
  carouselAligner: {
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      justifyContent: "flex-end",
    },
  },
  carouseldotAligner: {
    justifyContent: "flex-end",
  },
  cover: {
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: 0,
      zIndex: -1,
    },
  },
  carouselImage: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  carouselText: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    "& hr": {
      borderColor: "black",
      borderWidth: "0.5px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    "& h3": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("lg")]: {
      width: "610px",
    },
    "@media (min-width: 1280px) and (max-width: 1400px)": {
      marginLeft: "50px",
    },
  },
  extendedHr: {
    position: "absolute",
    width: "40%",
    top: "48px",
    right: "0",
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    "& hr": {
      borderColor: "black",
      borderWidth: "0.5px",
    },
  },
  pageBanner: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    // minHeight: "275px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "inset 0 0 0 300px rgba(212, 211, 225, 0.9)",
      backgroundPositionX: "75%!important",
    },
  },
  pageBannerNoOverlay: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    // minHeight: "275px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "inset 0 0 0 300px rgba(255, 255, 255, 0.7)",
      backgroundPositionX: "75%!important",
    },
    // [theme.breakpoints.down("sm")]: {
    //   boxShadow: "inset 0 0 0 300px rgba(212, 211, 225, 0.9)",
    //   backgroundPositionX: "75%!important",
    // },
  },
  navButton: {
    color: "#fff",
    marginRight: "5px",
    fontSize: "14px",
    [theme.breakpoints.up("lg")]: {
      fontSize: "18px",
      marginRight: "20px",
    },
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:focus": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  navaffix: {
    "& div > a:first-child": {
      marginLeft: "17px",
    },
  },
  // carousel styling
  multipleItemSlider: {
    width: "300px",
  },
  multiCarouselContent: {
    position: "relative",
    "& div": {
      backgroundColor: "rgba(237, 236, 237, 0.7)",
      position: "absolute",
      padding: "1.25rem",
      borderRadius: "6px",
      [theme.breakpoints.up("md")]: {
        marginLeft: "1.25rem",
        width: "50%",
        top: "50%",
        transform: "translateY(-50%)",
      },
      [theme.breakpoints.down("sm")]: {
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& button": {
          alignSelf: "flex-start",
        },
      },
    },
  },
  chevronPurple: {
    borderStyle: "solid",
    borderWidth: "3px",
    borderColor: theme.palette.secondary.main,
    fontSize: "3rem",
    color: theme.palette.secondary.main,
    borderRadius: "100%",
    position: "relative",
    top: "-20px",
    [theme.breakpoints.only("md")]: {
      fontSize: "2.5rem",
    },
  },
  chevronWhite: {
    borderStyle: "solid",
    borderWidth: "3px",
    borderColor: "#fff",
    fontSize: "3rem",
    color: "#fff",
    borderRadius: "100%",
    position: "relative",
    top: "-20px",
  },
  linkHover: {
    marginTop: "10px",
    padding: "0 20px",
    "& a:hover": {
      textDecoration: "underline!important",
      color: theme.palette.primary.main,
    },
  },

  search: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    display: "inline-flex",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    width: "85%",
    backgroundColor: "#fff",
    boxShadow: "3px 3px #888888",
    height: "50px",
    "& a:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  searchIcon: {
    width: theme.spacing(0),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
  },
  searchBtn: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "4px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(14),
  },
  card: {
    marginBottom: "25px",
    [theme.breakpoints.down("xs")]: {
      boxShadow: "none",
    },
  },
  actions: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  // about us css
  newsHeadline: {
    height: "46px",
    lineHeight: "1.2",
    overflow: "hidden",
  },
  newsBody: {
    height: "85px",
    overflow: "hidden",
  },

  brokerImg: {
    width: 190,
  },
  brokerInfo: {
    "& hr": {
      margin: "25px auto",
    },
    [theme.breakpoints.up("sm")]: {
      "& img": {
        width: "100%",
      },
    },
    "& img": {
      width: 200,
    },
  },
  firstColumn: {
    backgroundColor: "#c6d148",
    width: "35%",
  },
  // about
  aboutSlider: {
    backgroundColor: "#fff",
    display: "flex!important",
    margin: "0 auto",
    width: "95%!important",
  },

  promocardHeight: {
    [theme.breakpoints.between("sm", "md")]: {
      "& > p:first-child": {
        height: "45px",
      },
      "& p + p": {
        height: "115px",
      },
    },
    "@media (min-width: 1280px) and (max-width: 1550px)": {
      "& > p:first-child": {
        height: "45px",
      },
      "& p + p": {
        height: "140px",
      },
    },
    "@media (min-width: 1551px) and (max-width: 1919px)": {
      "& > p:first-child": {
        height: "45px",
      },
      "& p + p": {
        height: "115px",
      },
    },
    [theme.breakpoints.only("xl")]: {
      "& > p:first-child": {
        height: "45px",
      },
      "& p + p": {
        height: "120px",
      },
    },
  },
  uitfBG: {
    background: "url(../images/uitf/uitf-banner.jpg)",
    marginBottom: "35px",
    backgroundSize: "cover",
  },
  trustBG: {
    background: "url(../images/trust-products/trust-product-banner.jpg)",
    marginBottom: "35px",
    backgroundSize: "cover",
  },
  promoHeaderCTA: {
    flexBasis: "100%",
  },
});

const SectionTitle = withStyles(styles)(function ({
  header,
  fontColor,
  align,
}) {
  return (
    <Typography
      variant="h5"
      className="fontBold"
      color={fontColor}
      style={{ textAlign: align }}
      dangerouslySetInnerHTML={{ __html: header }}
    />
  );
});

const CashRenderPaperContent = withStyles(styles)(function ({
  img,
  headline,
  content,
  fontColor,
}) {
  return (
    <Grid container direction="column">
      <Grid container>
        <div className={`benefits-icon fa-solid icon30 icon-primary ${img}`} />
      </Grid>
      <Typography
        dangerouslySetInnerHTML={{ __html: headline }}
        variant="body1"
        gutterBottom
        color={fontColor}
        className="fontBold"
      />
      <Typography
        variant="body1"
        gutterBottom
        dangerouslySetInnerHTML={{ __html: content }}
        align="justify"
      />
    </Grid>
  );
});

const RenderPaperContent = withStyles(styles)(function ({
  img,
  headline,
  content,
  fontColor,
}) {
  return (
    <Grid container direction="column">
      <Grid container>
        <div
          className="benefits-icon "
          dangerouslySetInnerHTML={{ __html: img }}
        />
      </Grid>
      <Typography
        dangerouslySetInnerHTML={{ __html: headline }}
        variant="body1"
        gutterBottom
        color={fontColor}
        className="fontBold"
      />
      <Typography
        variant="body1"
        gutterBottom
        dangerouslySetInnerHTML={{ __html: content }}
        align="justify"
      />
    </Grid>
  );
});

const RenderPageBanner = withStyles(styles)(
  ({ minHeight = "275px", page, classes, noOverlay = false, ...props }) => {
    return (
      <section
        style={{
          backgroundImage: "url(" + props.banner + ")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          maxWidth: "100vw",
          minHeight,
        }}
        className={noOverlay ? classes.pageBannerNoOverlay : classes.pageBanner}
      >
        <div className="gridContainer">
          <Fragment>
            {page === "homepage" ? (
              props.children
            ) : (
              <div style={{ padding: "30px 20px" }}>{props.children}</div>
            )}
          </Fragment>
        </div>
      </section>
    );
  }
);

const RenderPageCompleteBanner = withStyles(styles)(
  ({ minHeight = "105px", page, classes, ...props }) => {
    return (
      <section
        style={{
          backgroundImage: "url(" + props.banner + ")",
          maxWidth: window.innerWidth,
          minHeight,
        }}
        className={classes.pageBanner}
      >
        <div className="gridContainer">
          <Fragment>
            {page === "homepage" ? (
              props.children
            ) : (
              <div style={{ padding: "30px 20px" }}>{props.children}</div>
            )}
          </Fragment>
        </div>
      </section>
    );
  }
);

const RenderHeaderSection = withStyles(styles)(function ({
  title,
  blurb,
  md = 5,
}) {
  return (
    <Grid container>
      <Grid item xs={12} md={md}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          <strong>{title}</strong>
        </Typography>
        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          dangerouslySetInnerHTML={{ __html: blurb }}
        />
      </Grid>
    </Grid>
  );
});

const RenderHeaderInsuranceSection = withStyles(styles)(function ({
  logo,
  blurb,
  md = 5,
}) {
  return (
    <Grid container>
      <Grid item xs={12} md={md}>
        <img
          src={logo}
          className="img-responsive"
          style={{ float: "left", width: "40%" }}
        />

        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          dangerouslySetInnerHTML={{ __html: blurb }}
          style={{ float: "left" }}
        />
      </Grid>
    </Grid>
  );
});

const RenderHeaderCompleteSection = withStyles(styles)(function ({
  title,
  blurb,
  md = 5,
}) {
  return (
    <Grid container>
      <Grid item xs={12} md={md}>
        <Typography variant="h6" component="h6" gutterBottom color="#00000">
          <strong>{title}</strong>
        </Typography>
        <Typography
          variant="subtitle1"
          gutterBottom
          color="#000000"
          dangerouslySetInnerHTML={{ __html: blurb }}
        />
      </Grid>
    </Grid>
  );
});

const RenderSupportHeader = withStyles(styles)(function ({ page, section }) {
  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom color="primary">
          {page}
        </Typography>
        <Typography
          variant={window.innerWidth < 960 ? "h5" : "h4"}
          gutterBottom
          color="primary"
        >
          <strong>{section}</strong>
        </Typography>
      </Grid>
    </Grid>
  );
});

const RenderPromoHeaderSection = withStyles(styles)(function ({
  title,
  subheading,
  blurb,
  disclaimer,
  cta_link = "",
  cta_title = "",
  classes,
}) {
  return (
    <Grid
      container
      spacing={0}
      className={classes.paperPadding}
      style={{ flexWrap: "wrap-reverse" }}
    >
      <Grid item xs={12} md={6} container alignItems="center">
        <Typography
          style={{ width: "100%" }}
          variant="h4"
          classname="fontBold"
          color="primary"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Typography
          variant="h5"
          gutterBottom
          color="secondary"
          dangerouslySetInnerHTML={{ __html: subheading }}
        />
        <Typography
          variant="body1"
          gutterBottom
          color="primary"
          dangerouslySetInnerHTML={{ __html: blurb }}
        />
        {cta_title !== "" ? (
          <div className={classes.promoHeaderCTA}>
            <Button
              size="medium"
              variant="contained"
              color="secondary"
              // className="buttons trackme"
              href={cta_link}
              target="_blank"
              className="buttons trackme"
              style={{ textAlign: "center" }}
            >
              {cta_title}
            </Button>
          </div>
        ) : null}

        <div style={{ marginTop: "10px", position: "relative", top: "20px" }}>
          <Typography
            variant="caption"
            gutterBottom
            dangerouslySetInnerHTML={{ __html: disclaimer }}
          />
        </div>
      </Grid>
    </Grid>
  );
});

const RenderBenefitFeaturesBusiness = withStyles(styles)(function ({
  header,
  classes,
  gridArray,
  fontColor,
  hideViewFullListButton,
}) {
  let content = gridArray.map((content) => {
    return content;
  });

  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor={fontColor} />
      <Grid container className={classnames(classes.borderZero)} item>
        {gridArray.slice(0, 3).map(function (data, index) {
          return (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              className={classes.benefitBorder}
            >
              <RenderPaperContentCashManagement
                img={data.img}
                headline={data.title}
                content={data.body}
                fontColor={fontColor}
              />
            </Grid>
          );
        })}
      </Grid>
      <div className={classnames(classes.paperPadding)}>
        {gridArray.length > 3 && !hideViewFullListButton ? (
          <DialogWindow
            title="FEATURES AND BENEFITS"
            body={
              <RenderExpansionContent contentArray={content} type="product" />
            }
            btnTitle="View full list"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

const RenderBenefitFeaturesInsurance = withStyles(styles)(function ({
  header,
  classes,
  gridArray,
  fontColor,
  hideViewFullListButton,
}) {
  let content = gridArray.map((content) => {
    return content;
  });

  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor={fontColor} />
      <Grid container className={classnames(classes.borderZero)} item>
        {gridArray.map(function (data, index) {
          return (
            <RenderPaperContentInsurance
              img={data.img}
              headline={data.title}
              content={data.body}
              fontColor={fontColor}
            />
          );
        })}
      </Grid>
    </div>
  );
});

const RenderBenefitFeatures = withStyles(styles)(function ({
  header,
  classes,
  gridArray,
  fontColor,
  hideViewFullListButton,
}) {
  let content = gridArray.map((content) => {
    return content;
  });

  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor={fontColor} style={{ textTransform: "capitalize" }} />
      <Grid container className={classnames(classes.borderZero)} item>
        {gridArray.slice(0, 3).map(function (data, index) {
          return (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              className={classes.benefitBorder}
            >
              <RenderPaperContent
                img={
                  data.img.includes("<i")
                    ? data.img
                    : "<i class='" + data.img + "' />"
                }
                headline={data.header}
                content={data.body}
                fontColor={fontColor}
              />
            </Grid>
          );
        })}
      </Grid>
      <div className={classnames(classes.paperPadding)}>
        {gridArray.length > 3 && !hideViewFullListButton ? (
          <DialogWindow
            title="FEATURES AND BENEFITS"
            body={
              <RenderExpansionContent contentArray={content} type="product" />
            }
            btnTitle="View full list"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

const RenderFeatureSection = withStyles(styles)(function ({
  classes,
  header,
  featurecontent,
  align,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" align={align} />
      <div className={classes.paperPadding}>
        <Grid container spacing={2}>
          {featurecontent.map(function (feature, index) {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md
                key={index}
                className={classes.cardfeaturesHeight}
              >
                <Card className={classes.rounderBorder}>
                  <CardMedia
                    image={
                      ewbConfig.appDomain +
                      feature.field_feature_image.replace(/\\\//g, "/")
                    }
                    className="cardImage"
                  />
                  <CardContent className={classes.homeCardHeight}>
                    <Typography
                      gutterBottom
                      variant="body1"
                      color="primary"
                      className="fontBold"
                      dangerouslySetInnerHTML={{ __html: feature.title }}
                    />
                    <Typography
                      variant="body1"
                      gutterBottom
                      dangerouslySetInnerHTML={{ __html: feature.field_blurb }}
                    />
                  </CardContent>
                  <CardActions>
                    {feature.field_link_type === "External" ? (
                      <Button
                        href={feature.field_link_url}
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className={classes.promoButton}
                      >
                        Learn More
                      </Button>
                    ) : (
                      <Button
                        component={Link}
                        to={feature.field_link_url}
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className={classes.promoButton}
                      >
                        Learn More
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

const CashRenderBenefitFeatures = withStyles(styles)(function ({
  header,
  classes,
  gridArray,
  fontColor,
}) {
  let content = gridArray.map((content) => {
    return content;
  });

  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor={fontColor} />
      <Grid container className={classnames(classes.borderZero)} item>
        {gridArray.slice(0, 3).map(function (data, index) {
          return (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              className={classes.benefitBorder}
            >
              <CashRenderPaperContent
                img={data.field_cash_icon}
                headline={data.title}
                content={data.field_cash_copy}
                fontColor={fontColor}
              />
            </Grid>
          );
        })}
      </Grid>
      <div className={classnames(classes.paperPadding)}>
        {gridArray.length > 3 ? (
          <DialogWindow
            title="FEATURES AND BENEFITS"
            body={
              <RenderExpansionContent contentArray={content} type="product" />
            }
            btnTitle="View full list"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

const RenderPromoSection = withStyles(styles)(function ({
  classes,
  header,
  promosArray,
  page,
  product,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classes.paperPadding}>
        <Grid container spacing={2}>
          {promosArray.map(function (promo, index) {
            return (
              <Grid item xs={12} sm={6} md key={index}>
                <Card className={classes.rounderBorder}>
                  <CardMedia image={promo.image} className="cardImage" />
                  <CardContent
                    className={
                      page === "home"
                        ? classes.homeCardHeight
                        : classes.cardHeight
                    }
                  >
                    <Typography
                      gutterBottom
                      variant="body1"
                      color="primary"
                      className="fontBold"
                      align={product == "creditcard" ? "justify" : "inherit"}
                    >
                      {promo.headline}
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      align={product == "creditcard" ? "justify" : "inherit"}
                    >
                      {promo.content}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      component={Link}
                      to={promo.link}
                      size="medium"
                      variant="contained"
                      color="secondary"
                      className={classes.promoButton}
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

const RenderPromoSectionCMS = withStyles(styles)(function ({
  classes,
  header,
  promosArray,
  page,
  product,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classes.paperPadding}>
        <Grid container spacing={2}>
          {promosArray.map(function (promo, index) {
            return (
              <Grid item xs={12} sm={6} md key={index}>
                <Card className={classes.rounderBorder}>
                  <CardMedia
                    image={
                      ewbConfig.appDomain + promo.image.replace(/\\\//g, "/")
                    }
                    className="cardImage"
                  />
                  <CardContent
                    className={
                      page === "home"
                        ? classes.homeCardHeight
                        : classes.cardHeight
                    }
                  >
                    <Typography
                      gutterBottom
                      variant="body1"
                      color="primary"
                      className="fontBold"
                      align={product == "creditcard" ? "justify" : "inherit"}
                    >
                      {promo.headline}
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      align={product == "creditcard" ? "justify" : "inherit"}
                    >
                      {promo.content}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      component={Link}
                      to={promo.link}
                      size="medium"
                      variant="contained"
                      color="secondary"
                      className={classes.promoButton}
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

const RenderExpansionContent = withStyles(styles)(function ({
  contentArray,
  classes,
  type,
}) {
  if (!contentArray) {
    return <div>Loading</div>;
  }
  return (
    <div className={classes.paperPadding}>
      <Grid container spacing={2}>
        {contentArray.map(function (data, index) {
          return (
            <Grid item xs={12} key={index}>
              <Typography
                gutterBottom
                color="primary"
                variant="body1"
                dangerouslySetInnerHTML={{ __html: data.header }}
                className="fontBold"
              />
              <Typography
                gutterBottom
                variant="body1"
                dangerouslySetInnerHTML={{ __html: data.body }}
                align={type == "product" ? "justify" : "inherit"}
              />
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
});

const BenefitsSection = function ({
  header,
  benefits,
  hideViewFullListButton,
}) {
  if (!benefits) {
    return <div>Loading</div>;
  }
  return (
    <RenderBenefitFeatures
      header={header}
      gridArray={benefits}
      fontColor="primary"
      hideViewFullListButton={hideViewFullListButton}
    />
  );
};

const CashBenefitsSection = function ({ header, benefits }) {
  if (!benefits) {
    return <div>Loading</div>;
  }
  return (
    <CashRenderBenefitFeatures
      header={header}
      gridArray={benefits}
      fontColor="primary"
    />
  );
};

const FeaturesSection = function ({ header, features }) {
  if (!features) {
    return <div>Loading</div>;
  }
  return (
    <RenderBenefitFeatures
      header={header}
      gridArray={features}
      fontColor="secondary"
    />
  );
};

const PromosSection = function ({ header, promos, product }) {
  if (!promos) {
    return <div>Loading</div>;
  }
  return (
    <RenderPromoSection
      header={header}
      promosArray={promos}
      product={product}
    />
  );
};

const CardServices = withStyles(styles)(function ({
  classes,
  header,
  cardServices,
  product,
  section,
}) {
  if (!cardServices) {
    return <div>Loading</div>;
  }
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classes.paperPadding} style={{ position: "relative" }}>
        <Grid container className={classnames(classes.borderZero)} spacing={2}>
          {cardServices.slice(0, 4).map(function (service, index) {
            return (
              <Grid
                item
                xs={12}
                md={3}
                key={index}
                className={classes.serviceBorder}
              >
                <Typography
                  variant="body1"
                  color="primary"
                  gutterBottom
                  className="fontBold"
                >
                  {service.header}
                </Typography>
                <Typography
                  variant="body1"
                  gutterBottom
                  dangerouslySetInnerHTML={{ __html: service.body }}
                  align="justify"
                />
                {section === "landing" && service.link != "" ? (
                  service.type == "ext" ? (
                    <Button
                      variant="contained"
                      size="medium"
                      color="secondary"
                      href={service.link}
                      className={classnames(classes.buttonBottom, "trackme")}
                      id={`btnlearnmore-helpsupport-${product}-${service.header}`.replace(
                        /\s+/g,
                        ""
                      )}
                    >
                      Learn more
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="medium"
                      color="secondary"
                      component={Link}
                      to={service.link}
                      className={classnames(classes.buttonBottom, "trackme")}
                      id={`btnlearnmore-helpsupport-${product}-${service.header}`.replace(
                        /\s+/g,
                        ""
                      )}
                    >
                      Learn more
                    </Button>
                  )
                ) : (
                  ""
                )}
              </Grid>
            );
          })}
        </Grid>
        <br />
        <br />
        {section === "landing" ? (
          ""
        ) : (
          <DialogWindow
            title={header}
            body={<CardServicesMobile contents={cardServices} type="product" />}
            btnTitle="View full list"
          />
        )}
      </div>
    </div>
  );
});

const CardServicesMobile = function ({ contents, classes, type }) {
  if (!contents) {
    return <div>Loading</div>;
  }
  return <RenderExpansionContent contentArray={contents} type="product" />;
};

const FeesAndChargesWeb = withStyles(styles)(function ({
  classes,
  tableContents,
  header,
  fontColor,
}) {
  if (!tableContents) {
    return <div>Loading</div>;
  }

  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor={fontColor} />
      <div className={classes.paperPadding}>
        <Table>
          <TableBody>
            {tableContents.slice(0, 5).map(function (data, index) {
              return (
                <TableRow key={index}>
                  <TableCell className={classes.feesFirst}>
                    <Typography
                      variant="body1"
                      align="center"
                      className="fontBold"
                      dangerouslySetInnerHTML={{ __html: data.header }}
                    />
                  </TableCell>
                  <TableCell className={classes.feesLast}>
                    <Typography
                      variant="body1"
                      dangerouslySetInnerHTML={{ __html: data.body }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {tableContents.length > 5 ? (
          <Fragment>
            <br />
            <br />
            <DialogWindow
              title="FEES AND CHARGES"
              body={<FeesAndChargesMobile contents={tableContents} />}
              btnTitle="View full list"
            />
          </Fragment>
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

const FeesAndChargesMobile = withStyles(styles)(function ({ contents }) {
  if (!contents) {
    return <div>Loading</div>;
  }
  return <RenderExpansionContent contentArray={contents} type="product" />;
});

const PromoCardBox = withStyles(styles)(function ({ promo, classes, product }) {
  return (
    <Card className={classes.rounderBorder}>
      <CardMedia
        image={
          ewbConfig.appDomain +
          promo.field_promo_feature_image.replace(/\\\//g, "/")
        }
        className="cardImage"
        style={{ backgroundPositionY: "top" }}
      />
      <CardContent className={classes.promocardHeight}>
        <Typography
          gutterBottom
          variant="body1"
          color="primary"
          className="fontBold"
          dangerouslySetInnerHTML={{ __html: promo.title }}
        />
        <Typography
          variant="body1"
          gutterBottom
          align={product == "creditcard" ? "justify" : "inherit"}
          dangerouslySetInnerHTML={{ __html: promo.field_blurb }}
        />
        {promo.field_promo_duration.length > 0 ? (
          <Typography variant="caption" gutterBottom>
            Promo period: {promo.field_promo_duration}
          </Typography>
        ) : (
          <Typography variant="caption" gutterBottom>
            &nbsp;
          </Typography>
        )}
      </CardContent>
      <CardActions>
        <Button
          style={{ width: "100%" }}
          component={Link}
          to={
            promo.url_alias.search("/node/") < 0
              ? promo.url_alias
              : `/promos/${promo.nid}`
          }
          size="medium"
          variant="contained"
          color="secondary"
        >
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
});

const RenderApplicationStepsContent = withStyles(styles)(function ({
  classes,
  number,
  instruction,
}) {
  return (
    <Grid item xs={12} md={4}>
      <Typography
        variant="h5"
        gutterBottom
        align="center"
        className={classes.rounderNumber}
      >
        {number}
      </Typography>
      <Hidden smDown>
        <img
          alt="Eastwest Bank instruction"
          src="/images/eastwestbank-chevron.png"
          style={{ float: "right", transform: "translateY(-125%)" }}
        />
      </Hidden>
      <Typography
        variant="body1"
        gutterBottom
        align="center"
        color="primary"
        dangerouslySetInnerHTML={{ __html: instruction }}
      />
    </Grid>
  );
});

const RenderApplicationSteps = withStyles(styles)(function ({
  header,
  applicationSteps,
  classes,
  stepheader,
  url,
}) {
  if (!applicationSteps) {
    return <div>Loading</div>;
  }

  return (
    <div className={classnames(classes.paperPadding, classes.spacer)}>
      <div style={{ border: "1px solid #d6d6d6", borderRadius: "20px" }}>
        <div className={classes.paperPadding}>
          <SectionTitle header={header} fontColor="primary" />
          {stepheader !== undefined ? (
            <Typography
              variant="body1"
              gutterBottom
              style={{ marginTop: "20px", fontWeight: "bold" }}
              color="primary"
              dangerouslySetInnerHTML={{ __html: stepheader }}
            />
          ) : (
            ""
          )}
          <div className={classes.paperPadding}>
            <Grid container className={classes.applySteps} spacing={2}>
              {applicationSteps.map((steps) => {
                return (
                  <RenderApplicationStepsContent
                    number={steps.number}
                    instruction={steps.instruction}
                    key={steps.number}
                  />
                );
              })}
            </Grid>
          </div>
          {url === "/deposits/pesosavings" ||
            url === "/deposits/pesochecking" ||
            url === "/deposits/tiereddeposit" ||
            url === "/deposits/tiereddeposit" ? (
            <div
              className={classes.paperPadding}
              style={{ marginTop: "-30px" }}
            >
              <Grid direction="column" alignItems="flex-start" container>
                <Grid item xs={12}>
                  <br />
                  <Typography variant="body1" gutterBottom color="primary">
                    For existing deposit customers
                  </Typography>
                  <Button
                    size="medium"
                    variant="contained"
                    color="secondary"
                    component={Link}
                    className="buttons trackme"
                    to={REQUEST_FOR_CALLBACK_DEPOSIT_PAGE}
                    target="_blank"
                  >
                    Request for a Call Back here.
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
});

const RenderHelpSection = withStyles(styles)(function ({
  classes,
  header,
  promosArray,
  page,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classes.paperPadding}>
        <Grid container spacing={2}>
          {promosArray.map(function (promo, index) {
            return (
              <Grid item xs={12} sm={6} md key={index}>
                <Card className={classes.rounderBorder}>
                  <CardMedia image={promo.image} className="cardImage" />
                  <CardContent
                    className={
                      page === "home"
                        ? classes.homeCardHeight
                        : classes.cardHeight
                    }
                  >
                    <Typography
                      gutterBottom
                      variant="body1"
                      color="primary"
                      className="fontBold"
                    >
                      {promo.headline}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {promo.content}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <AnchorLink
                      className={classes.promoButton}
                      to={promo.link}
                      style={{ textDecoration: "none" }}
                      scroll={(el) =>
                        el.scrollIntoView({ behavior: "smooth", block: "end" })
                      }
                    >
                      <Button
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className={classes.promoButton}
                      >
                        Learn More
                      </Button>
                    </AnchorLink>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

const RenderProductsData = withStyles(styles)(function ({
  classes,
  products,
  url,
  cta,
}) {
  return products.map((product) => {
    if (product.field_not_to_display != "On") {
      return (
        <Paper
          elevation={1}
          className={classes.cardPadding}
          style={{ width: "100%" }}
          key={product.productname}
        >
          <Grid
            container
            spacing={2}
            style={{ flexWrap: "wrap-reverse" }}
            className="productHeight"
          >
            <Grid item xs={12} sm={12} md container>
              <Grid item xs container direction="column">
                <Grid item xs>
                  <Typography gutterBottom variant="h5">
                    {product.productname}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="h6"
                    dangerouslySetInnerHTML={{ __html: product.headline }}
                  />
                  <Typography
                    variant="body1"
                    gutterBottom
                    dangerouslySetInnerHTML={{ __html: product.subheadline }}
                    className={classes.subheadline}
                  />
                  {product.field_no_apply_button === "Yes" ? (
                    product.linktype === "ext" ? (
                      <Button
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className="buttons trackme"
                        href={product.link}
                        target="_blank"
                        id={`btnlearnmore-landingpage-${product.productname}`.replace(
                          /\s+/g,
                          ""
                        )}
                      >
                        LEARN MORE
                      </Button>
                    ) : url === "/investments" ? (
                      <Button
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className="buttons trackme"
                        component={Link}
                        to={product.link}
                        id={`btnlearnmore-landingpage-${product.productname}`.replace(
                          /\s+/g,
                          ""
                        )}
                      >
                        LEARN MORE
                      </Button>
                    ) : (
                      <Button
                        size="medium"
                        variant="contained"
                        color="secondary"
                        className="buttons trackme"
                        component={Link}
                        to={url + "/" + product.field_url_slug}
                        id={`btnlearnmore-landingpage-${product.productname}`.replace(
                          /\s+/g,
                          ""
                        )}
                      >
                        LEARN MORE
                      </Button>
                    )
                  ) : (
                    <Fragment>
                      {url === "/creditcards" ? (
                        <Button
                          size="medium"
                          variant="contained"
                          color="secondary"
                          className="buttons trackme"
                          href={product.link}
                          target="_blank"
                          id={`btnapply-landingpage-${product.productname}`}
                        >
                          APPLY NOW
                        </Button>
                      ) : (
                        <RenderFabButton
                          formtype="creditcard"
                          formval={product.formval}
                          productType={product.nodeId}
                          id={`btnapply-landingpage-${product.productname}`}
                          cta={cta != "" ? cta : ""}
                        />
                      )}
                      {product.nodeId !== "" || product.linktype !== "ext" ? (
                        <Button
                          size="medium"
                          variant="outlined"
                          color="secondary"
                          className="buttons trackme"
                          component={Link}
                          to={url + "/" + product.field_url_slug}
                          id={`btnlearnmore-landingpage-${product.productname}`.replace(
                            /\s+/g,
                            ""
                          )}
                        >
                          LEARN MORE
                        </Button>
                      ) : (
                        <Button
                          size="medium"
                          variant="outlined"
                          color="secondary"
                          className="buttons trackme"
                          href={product.link}
                          target="_blank"
                          id={`btnlearnmore-landingpage-${product.productname}`.replace(
                            /\s+/g,
                            ""
                          )}
                        >
                          LEARN MORE
                        </Button>
                      )}
                    </Fragment>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={4}>
              <img
                src={ewbConfig.appDomain + product.image.replace(/\\\//g, "/")}
                alt={product.productname}
                className="img-responsive"
              />
            </Grid>
          </Grid>
        </Paper>
      );
    }
  });
});

const RenderProducts = withStyles(styles)(function ({
  classes,
  cardContents,
  url,
  cta,
}) {
  if (!cardContents) {
    return <div>Loading</div>;
  }
  return (
    <Grid
      container
      className={classnames("gridContainer", classes.cardPadding)}
      item
      sm={8}
      md={10}
    >
      <RenderProductsData products={cardContents} url={url} cta={cta} />
    </Grid>
  );
});

const RenderExpansionCardContent = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: false,
        expandedText: "SHOW PRODUCT FEATURES",
      };
    }

    handleExpandClick = () => {
      this.setState({
        expanded: !this.state.expanded,
      });

      if (this.state.expanded != false) {
        this.setState({
          expandedText: "SHOW PRODUCT FEATURES",
        });
      } else {
        this.setState({
          expandedText: "HIDE PRODUCT FEATURES",
        });
      }
    };

    render() {
      const { classes, contentArray } = this.props;

      return (
        <Card className={classes.card}>
          <CardContent>
            <Grid container spacing={2} style={{ flexWrap: "wrap-reverse" }}>
              <Grid item xs={12} sm={12} md container>
                <Grid item xs container direction="column">
                  <Grid item xs>
                    <Typography
                      variant="body1"
                      dangerouslySetInnerHTML={{ __html: contentArray.blurb }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={4}>
                <img
                  alt={contentArray.img}
                  src={contentArray.img}
                  className="img-responsive"
                />
              </Grid>
            </Grid>
          </CardContent>

          <CardActions className={classes.actions} disableActionSpacing>
            <Button
              color="secondary"
              size="medium"
              className={classnames("buttons", classes.expand)}
              onClick={this.handleExpandClick}
              aria-expanded={this.state.expanded}
            >
              Learn More
            </Button>
          </CardActions>

          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent>
              {contentArray.contents.map(function (content, i) {
                return (
                  <Typography key={i} gutterBottom variant="body1">
                    {content.body}
                  </Typography>
                );
              })}
            </CardContent>
          </Collapse>
        </Card>
      );
    }
  }
);

const NavAffix = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        navPosition: "static",
        navPosMargin: "0px",
      };
      this.handleScroll = this.handleScroll.bind(this);
      this.loadAffix = this.loadAffix.bind(this);
    }

    componentDidMount() {
      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("load", this.loadAffix);
    }

    componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    }

    loadAffix(event) {
      this.setState({
        navPosition: "static",
        navPosMargin: "0px",
      });
    }

    handleScroll(event) {
      if (
        window.scrollY >= document.getElementById("pageBanner").offsetHeight
      ) {
        this.setState({
          navPosition: "fixed",
          navPosMargin: "64px",
        });
      } else {
        this.setState({
          navPosition: "static",
          navPosMargin: "0px",
        });
      }
    }
    render() {
      let { classes, tabsContent, hasAnalyticsListener, page } = this.props;
      return (
        <Fragment>
          <Hidden smDown>
            <AppBar
              position={this.state.navPosition}
              style={{ marginTop: this.state.navPosMargin }}
              className={classes.navaffix}
            >
              <Toolbar className="gridContainer" disableGutters>
                {tabsContent.map(function (tab, index) {
                  return tab.type !== "ext" ? (
                    <Scrollchor
                      key={index}
                      to={tab.link}
                      animate={{ offset: tab.offset }}
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        className={classes.navButton}
                        onClick={() => {
                          if (hasAnalyticsListener) {
                            eventTracker(
                              page,
                              `${ACTIONS.NAV_AFFIX_CLICK
                              }_${tab.menu.toUpperCase()}`,
                              `$${page}_${LABELS.NAV_AFFIX_SECTION_MENU}_${tab}`
                            );
                          }
                        }}
                      >
                        <span dangerouslySetInnerHTML={{ __html: tab.menu }} />
                      </Button>
                    </Scrollchor>
                  ) : (
                    <Link to={tab.link} style={{ textDecoration: "none" }}>
                      <Button
                        className={classes.navButton}
                        onClick={() => {
                          if (hasAnalyticsListener) {
                            eventTracker(
                              page,
                              `${ACTIONS.NAV_AFFIX_CLICK
                              }_${tab.menu.toUpperCase()}`,
                              `$${page}_${LABELS.NAV_AFFIX_SECTION_MENU}_${tab}`
                            );
                          }
                        }}
                      >
                        <span dangerouslySetInnerHTML={{ __html: tab.menu }} />
                      </Button>
                    </Link>
                  );
                })}
              </Toolbar>
            </AppBar>
          </Hidden>
          <div style={{ marginBottom: this.state.navPosMargin }} />
        </Fragment>
      );
    }
  }
);

NavAffix.defaultProps = {
  hasAnalyticsListener: false,
  page: "",
};

const FAQExpansion = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: this.props.open,
      };
    }

    handleExpanded = (panel) => (event, expanded) => {
      this.setState({
        expanded: expanded ? panel : false,
      });
    };

    render() {
      let { classes, expansionContents, headerSize } = this.props;

      return (
        <div
          elevation={0}
          className={
            headerSize === "small"
              ? classes.paperPadding
              : classnames(classes.spacer, classes.paperPadding)
          }
        >
          {expansionContents.map((expansionContent, x) => {
            return (
              <ExpansionPanel
                expanded={this.state.expanded === `panel${x}`}
                onChange={this.handleExpanded(`panel${x}`)}
                key={x}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon color="primary" />}
                >
                  {headerSize === "small" ? (
                    <Typography className={classes.heading}>
                      {expansionContent.header}
                    </Typography>
                  ) : (
                    <Typography variant="h6">
                      {expansionContent.header}
                    </Typography>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {headerSize === "small" ? (
                    <Typography
                      variant="body2"
                      dangerouslySetInnerHTML={{
                        __html: expansionContent.body,
                      }}
                    />
                  ) : (
                    <Typography
                      variant="body1"
                      dangerouslySetInnerHTML={{
                        __html: expansionContent.body,
                      }}
                    />
                  )}
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          })}
        </div>
      );
    }
  }
);

const SupportQuickLinksContent = withStyles(styles)(function ({
  classes,
  linksArray,
  pagetitle,
  link,
}) {
  if (!pagetitle || !link) {
    return <span />;
  }

  return (
    <>
      <Paper style={{ padding: "15px", marginBottom: "1rem" }}>
        <Link
          to={link}
          style={{ textDecoration: "none", display: "flex", color: "#542785" }}
        >
          <ChevronLeft style={{ verticalAlign: "middle", fontSize: "30px" }} />
          <Typography variant="h5" color="primary" className="fontBold">
            {pagetitle}
          </Typography>
        </Link>
      </Paper>
      {!linksArray ? (
        ""
      ) : (
        <Paper style={{ padding: "15px" }}>
          <Grid container direction="row">
            <Typography variant="h6" color="primary">
              Related topics
            </Typography>
          </Grid>
          {linksArray.map(function (link, index) {
            return (
              <div className={classes.linkHover} key={index}>
                {link.type === "ext" ? (
                  <a
                    href={link.link}
                    style={{ textDecoration: "none" }}
                    target="_blank"
                  >
                    <Typography variant="body1">{link.title}</Typography>
                  </a>
                ) : (
                  <Typography
                    variant="body1"
                    component={Link}
                    to={link.link}
                    style={{ textDecoration: "none" }}
                  >
                    {link.title}
                  </Typography>
                )}
              </div>
            );
          })}
        </Paper>
      )}
    </>
  );
});

const SupportQuickLinks = withStyles(styles)(function ({
  classes,
  linksArray,
  pagetitle,
  link,
  grid = true,
}) {
  const Content = (
    <SupportQuickLinksContent
      linksArray={linksArray}
      link={link}
      pagetitle={pagetitle}
    />
  );
  if (!pagetitle || !link) {
    return <span />;
  }

  if (!grid) {
    return Content;
  }
  return (
    <Grid
      item
      md={4}
      className={classnames(classes.spacer, classes.paperPadding)}
    >
      {Content}
    </Grid>
  );
});

const RenderExpansionContentTable = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: this.props.open,
      };
    }

    handleExpanded = (panel) => (event, expanded) => {
      this.setState({
        expanded: expanded ? panel : false,
      });
    };

    render() {
      let { classes, expansionContents } = this.props;

      return (
        <div
          elevation={0}
          className={classnames(classes.spacer, classes.paperPadding)}
        >
          {expansionContents.map((expansionContent, x) => {
            return (
              <ExpansionPanel
                expanded={this.state.expanded === `panel${x}`}
                onChange={this.handleExpanded(`panel${x}`)}
                key={x}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon color="primary" />}
                >
                  <Typography variant="h6">
                    {expansionContent.header}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ display: "block" }}>
                  <RenderExpansionContent
                    contentArray={expansionContent.contents}
                  />
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          })}
        </div>
      );
    }
  }
);

class DialogWindow extends Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { title, body, btnTitle } = this.props;
    return (
      <Fragment>
        <Button onClick={this.handleOpen} variant="contained" color="secondary">
          {btnTitle}
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{title}</DialogTitle>
          <DialogContent>{body}</DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary" size="medium">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const SearchBar = withStyles(styles)(function ({ classes }) {
  return (
    <div style={{ textAlign: "center" }}>
      <div className={classes.search}>
        <Input
          placeholder="Search..."
          disableUnderline
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
        />
        <Button
          component={Link}
          to="/supportandsecurity/search-results"
          className={classes.searchBtn}
          disableFocusRipple={true}
          disableRipple={true}
        >
          <div className={classes.searchIcon}>
            <Search />
          </div>
        </Button>
      </div>
    </div>
  );
});

const RenderModalButton = withStyles(styles, { withTheme: true })(
  class extends Component {
    state = {
      open: false,
    };

    handleClickOpen = () => {
      this.setState({ open: true });
    };

    handleClose = () => {
      this.setState({ open: false });
    };

    render() {
      const { buttonTitle, header, dialogBody, classes } = this.props;
      return (
        <Fragment>
          <Button
            color="secondary"
            className={classes.modalButtonStyling}
            onClick={this.handleClickOpen}
          >
            {buttonTitle}
          </Button>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">{header}</DialogTitle>
            <DialogContent>{dialogBody}</DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Fragment>
      );
    }
  }
);

const SingleSlider = withStyles(styles, {
  withTheme: true,
})(
  class extends Component {
    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        className: "single-slider",
        nextArrow: <SampleNextArrow color="white" />,
        prevArrow: <SamplePrevArrow color="white" />,
        responsive: [
          {
            breakpoint: 1279,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "50px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrows: false,
            },
          },
          {
            breakpoint: 991,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "30px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrows: false,
            },
          },
        ],
        appendDots: (dots) => (
          <div>
            <Grid container>
              <Grid container item sm={12} lg={12}>
                <Grid item className="gridContainer">
                  <ul className="carousel-ul-styling">
                    <div>{dots}</div>
                  </ul>
                </Grid>
              </Grid>
            </Grid>
          </div>
        ),
      };
      const {
        classes,
        carouselContents,
        header,
        fontColor,
        type,
        addApiConfigToImage = false,
      } = this.props;
      return (
        <div className={classes.spacer}>
          <div className="gridContainer">
            <div className={classes.paperPadding}>
              <SectionTitle header={header} fontColor={fontColor} />
            </div>
          </div>
          <Slider {...settings}>
            {carouselContents.map((carouselContent) => {
              return (
                <article
                  className={classes.carouselStyling}
                  key={carouselContent.headline}
                >
                  <Grid container>
                    <Grid
                      className={classnames(classes.carouselAligner)}
                      container
                      item
                      sm={12}
                      lg={6}
                    >
                      {type !== "promobanner" ? (
                        <Grid item className="gridContainerHalf">
                          <Grid item xs={12} className={classes.carouselText}>
                            <Typography
                              variant="body1"
                              color="primary"
                              gutterBottom
                              align="left"
                            >
                              {carouselContent.category}
                            </Typography>
                            <hr />
                            <section>
                              <Typography
                                variant="h5"
                                color="primary"
                                gutterBottom
                                align="left"
                                style={{ fontWeight: "600" }}
                              >
                                {carouselContent.headline}
                              </Typography>
                              <Typography
                                variant="body1"
                                gutterBottom
                                align="left"
                                dangerouslySetInnerHTML={{
                                  __html: carouselContent.body,
                                }}
                              />
                              <br />
                              <Button
                                component={Link}
                                to={carouselContent.link}
                                size="large"
                                variant="contained"
                                color="secondary"
                              >
                                {carouselContent.cta}
                              </Button>
                            </section>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid item>
                          <Grid item xs={12} className={classes.carouselText}>
                            <section className="position-relative productpromobanner">
                              <Typography
                                variant="h5"
                                color="primary"
                                gutterBottom
                                align="left"
                                style={{ fontWeight: "600" }}
                              >
                                {carouselContent.headline}
                              </Typography>
                              <Typography
                                variant="body1"
                                gutterBottom
                                align="left"
                                color="primary"
                                dangerouslySetInnerHTML={{
                                  __html: carouselContent.body,
                                }}
                              />
                              <br />
                              {carouselContent.linktype === "ext" ||
                                carouselContent.linktype === "External" ? (
                                <Button
                                  href={carouselContent.link}
                                  target="_blank"
                                  size="large"
                                  variant="contained"
                                  color="secondary"
                                >
                                  {carouselContent.cta}
                                </Button>
                              ) : (
                                <Button
                                  component={Link}
                                  to={carouselContent.link}
                                  size="large"
                                  variant="contained"
                                  color="secondary"
                                >
                                  {carouselContent.cta}
                                </Button>
                              )}
                            </section>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs={12} lg={6} style={{ width: "100%" }}>
                      <CardMedia
                        className={classes.cover}
                        image={
                          carouselContent.image?.includes(ewbConfig.apiUrl) ||
                            addApiConfigToImage === false
                            ? carouselContent.image
                            : ewbConfig.apiUrl + carouselContent.image
                        }
                        title={carouselContent.headline}
                      />
                    </Grid>
                  </Grid>
                </article>
              );
            })}
          </Slider>
        </div>
      );
    }
  }
);

export const SampleNextArrow = withStyles(styles)(function (props) {
  const { className, style, onClick, classes, color } = props;
  return (
    <Hidden smDown>
      <div className={className} style={{ ...style }} onClick={onClick}>
        {color == "white" ? (
          <ChevronRight className={classes.chevronWhite} />
        ) : (
          <ChevronRight className={classes.chevronPurple} />
        )}
      </div>
    </Hidden>
  );
});

const SamplePrevArrow = withStyles(styles)(function (props) {
  const { className, style, onClick, classes, color } = props;
  return (
    <Hidden smDown>
      <div className={className} style={{ ...style }} onClick={onClick}>
        {color == "white" ? (
          <ChevronLeft className={classes.chevronWhite} />
        ) : (
          <ChevronLeft className={classes.chevronPurple} />
        )}
      </div>
    </Hidden>
  );
});

const MultipleSlider = withStyles(styles)(
  class MultipleSlider extends Component {
    render() {
      const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        lazyLoad: true,
        className: "multiple-slider",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,

        responsive: [
          {
            breakpoint: 960,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "16px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrow: "false",
            },
          },
        ],
      };
      const { carouselContents, header, classes } = this.props;
      return (
        <div className={classnames(classes.spacer)}>
          <div className={classnames(classes.paperPadding)}>
            <SectionTitle header={header} fontColor="primary" />
          </div>
          <Slider {...settings}>
            {carouselContents.map((carouselContent) => {
              return (
                <article
                  key={carouselContent.image}
                  className={classes.multiCarouselContent}
                >
                  <img
                    style={{ width: "99%" }}
                    src={carouselContent.image}
                    alt={carouselContent.alt}
                    className="img-responsive"
                  />
                  <div className={classes.multiCarouselContent}>
                    <Typography
                      variant="h6"
                      color="primary"
                      gutterBottom
                      align="left"
                    >
                      <strong>{carouselContent.headline}</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      align="left"
                      dangerouslySetInnerHTML={{ __html: carouselContent.body }}
                    />
                    <Button size="large" variant="contained" color="secondary">
                      {carouselContent.cta}
                    </Button>
                  </div>
                </article>
              );
            })}
          </Slider>
        </div>
      );
    }
  }
);

const MultipleSliderV1 = withStyles(styles)(
  class MultipleSlider extends Component {
    render() {
      const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        lazyLoad: true,
        className: "multiple-slider",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,

        responsive: [
          {
            breakpoint: 960,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "50px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrow: "false",
            },
          },
          {
            breakpoint: 500,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "30px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrow: "false",
            },
          },
        ],
      };
      const { carouselContents, header, classes } = this.props;
      return (
        <div className={classnames(classes.spacer)}>
          <div className={classnames(classes.paperPadding)}>
            <SectionTitle header={header} fontColor="primary" />
          </div>
          <Slider {...settings}>
            {carouselContents.map((carouselContent) => {
              return (
                <article
                  key={carouselContent.image}
                  className={classes.multiCarouselContent}
                >
                  <img
                    style={{ width: "99%" }}
                    src={carouselContent.image}
                    alt={carouselContent.alt}
                    className="img-responsive"
                  />
                </article>
              );
            })}
          </Slider>
        </div>
      );
    }
  }
);

const RenderBenefitFeaturesCashManagement = withStyles(styles)(function ({
  classes,
  gridArray,
  fontColor,
  hideViewFullListButton,
}) {
  let content = gridArray.map((content) => {
    return content;
  });

  return (
    <div
      className={classnames(classes.spacer, classes.paperPaddingCashManagement)}
    >
      <Grid container className={classnames(classes.borderZero)} item>
        {gridArray.slice(0, 3).map(function (data, index) {
          return (
            <Grid
              item
              xs={12}
              md={4}
              key={index}
              className={classes.benefitBorderCashManagement}
            >
              <RenderPaperContentCashManagement
                headline={data.title}
                content={data.body}
                fontColor={fontColor}
              />
            </Grid>
          );
        })}
      </Grid>
      <div className={classnames(classes.paperPadding)}>
        {gridArray.length > 3 && !hideViewFullListButton ? (
          <DialogWindow
            title="FEATURES AND BENEFITS"
            body={
              <RenderExpansionContent contentArray={content} type="product" />
            }
            btnTitle="View full list"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

const BenefitsSectionCashManagement = function ({
  benefits,
  hideViewFullListButton,
}) {
  if (!benefits) {
    return <div>Loading</div>;
  }
  return (
    <RenderBenefitFeaturesBusiness
      gridArray={benefits}
      fontColor="primary"
      hideViewFullListButton={hideViewFullListButton}
    />
  );
};

const BenefitsSectionInsurance = function ({
  benefits,
  hideViewFullListButton,
}) {
  if (!benefits) {
    return <div>Loading</div>;
  }
  return (
    <RenderBenefitFeaturesInsurance
      gridArray={benefits}
      fontColor="primary"
      hideViewFullListButton={hideViewFullListButton}
    />
  );
};

const MultipleSliderAbout = withStyles(styles)(
  class MultipleSlider extends Component {
    render() {
      const settings = {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        lazyLoad: true,
        className: "multiple-slider",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,

        responsive: [
          {
            breakpoint: 960,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "50px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrow: "false",
            },
          },
          {
            breakpoint: 500,
            arrows: false,
            settings: {
              centerMode: true,
              centerPadding: "30px",
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              arrow: "false",
            },
          },
        ],
      };
      const { carouselContents, header, classes } = this.props;
      return (
        <div className={classnames(classes.spacer)}>
          <div className={classnames(classes.paperPadding)}>
            <Typography color="secondary" variant="h6">
              <strong>{header}</strong>
            </Typography>
          </div>
          <Slider {...settings}>
            {carouselContents.map((carouselContent, index) => {
              return (
                <div className={classes.aboutSlider} key={index}>
                  <Grid
                    justify="center"
                    alignItems="center"
                    container
                    key={index}
                  >
                    <Grid item xs={1} />
                    <Grid xs={6}>
                      <Typography variant="h6" color="primary">
                        <strong>{carouselContent.headline}</strong>
                      </Typography>
                      <Typography
                        style={{ lineHeight: "1" }}
                        variant="body1"
                        className="fontBold"
                        gutterBottom
                        color="secondary"
                        dangerouslySetInnerHTML={{
                          __html: carouselContent.position,
                        }}
                      />
                    </Grid>
                    <Grid xs={5}>
                      <img
                        src={
                          ewbConfig.appDomain +
                          carouselContent.image.replace(/\\\//g, "/")
                        }
                        className="img-responsive"
                      />
                    </Grid>
                  </Grid>
                </div>
              );
            })}
          </Slider>
        </div>
      );
    }
  }
);

const MultipleItemSlider = withStyles(styles)(
  class MultipleSlider extends Component {
    constructor(props) {
      super(props);
      this.state = {
        throttled: false,
      };
    }

    resize = () => {
      if (!this.state.throttled) {
        // actual callback action
        this.forceUpdate();
        // we're throttled!
        // throttled = true;
        this.setState({
          throttled: true,
        });
        // set a timeout to un-throttle
        setTimeout(() => {
          this.setState({
            throttled: false,
          });
        }, 500);
      }
    };

    componentDidMount() {
      window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.resize);
    }

    render() {
      if (!this.props.carouseldata) {
        return <div>loading</div>;
      }

      let slideScrollLG, slideScrollMD, slideScrollSM;

      let carouseldata1 = this.props.carouseldata;
      let setWidthClass = "";

      if (carouseldata1.length < 3) {
        setWidthClass = "multiple-slider setLessThanThreeCardWidth";
      }

      if (carouseldata1.length >= 3) {
        slideScrollLG = 3;
        slideScrollMD = 2;
        setWidthClass = "multiple-slider setThreeCardWidth";
      } else {
        slideScrollLG = carouseldata1.length;
        slideScrollMD = carouseldata1.length;
      }

      var settings = {
        lazyLoad: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: slideScrollLG,
        slidesToScroll: slideScrollLG,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        className: setWidthClass,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              className: setWidthClass,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrow: "false",
              centerMode: true,
              centerPadding: "16px",
            },
          },
        ],
      };
      const { carouseldata, header, classes } = this.props;
      return (
        <div className={classnames(classes.spacer)}>
          <div className={classnames(classes.paperPadding)}>
            <SectionTitle header={header} fontColor="primary" />
          </div>
          <Slider {...settings}>
            {carouseldata.map((carouselContent, index) => {
              return (
                <article className={classes.multipleItemSlider} key={index}>
                  <Card className={classes.rounderBorder}>
                    <CardMedia
                      image={carouselContent.image}
                      className="cardImage"
                    />
                    <CardContent className={classes.cardHeight}>
                      <Typography
                        gutterBottom
                        variant="body1"
                        color="primary"
                        className="fontBold"
                      >
                        {carouselContent.headline}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        {carouselContent.content}
                      </Typography>
                    </CardContent>
                  </Card>
                </article>
              );
            })}
          </Slider>
          <br />
        </div>
      );
    }
  }
);

const RenderPromoCard = withStyles(styles)(function ({
  classes,
  header,
  promosArray,
}) {
  return (
    <div>
      <Grid container spacing={2}>
        {promosArray.map(function (promo, index) {
          return (
            <Grid item xs={12} sm={6} lg={4} xl={3} key={index}>
              <Card className={classes.rounderBorder}>
                <CardMedia image={promo.image} className="cardImage" />
                <CardContent className={classes.cardHeight}>
                  <Typography
                    gutterBottom
                    variant="body1"
                    color="primary"
                    className="fontBold"
                  >
                    {promo.headline}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {promo.content}
                  </Typography>
                  <Typography variant="caption" gutterBottom>
                    Promo period: {promo.duration}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    component={Link}
                    to={promo.link}
                    size="medium"
                    variant="contained"
                    color="secondary"
                    className={classes.promoButton}
                  >
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
});

const PromoQuickLinksContent = withStyles(styles)(function ({
  classes,
  linksArray,
  fontColor,
}) {
  return (
    <>
      <Paper style={{ padding: "15px", marginBottom: "1rem" }}>
        <Grid container direction="row">
          <i className="far fa-credit-card icon30 icon-primary" /> &nbsp; &nbsp;{" "}
          <SectionTitle header="Eligible Credit Card " fontColor={fontColor} />
        </Grid>
      </Paper>
      <Paper style={{ padding: "15px" }}>
        <Grid container direction="row" />
        {linksArray.map(function (link, index) {
          return (
            <div className={classes.linkHover}>
              <Typography
                variant="body1"
                component={Link}
                to={link.link}
                style={{ textDecoration: "none" }}
              >
                {link.title}
              </Typography>
            </div>
          );
        })}
      </Paper>
    </>
  );
});

const PromoQuickLinks = withStyles(styles)(function ({
  classes,
  linksArray,
  fontColor,
  grid = true,
}) {
  const Content = (
    <PromoQuickLinksContent linksArray={linksArray} fontColor={fontColor} />
  );

  if (!grid) {
    return Content;
  }
  return (
    <Grid
      item
      md={4}
      className={classnames(classes.spacer, classes.paperPadding)}
    >
      {Content}
    </Grid>
  );
});

const Listicle = withStyles(styles)(function ({
  classes,
  lists,
  header,
  datasource,
}) {
  if (!lists) {
    return <div>Loading</div>;
  }

  return (
    <div className={classnames(classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classnames(classes.paperPadding)}>
        <List component="nav">
          {lists.map((list) => {
            let filelink;
            if (datasource == "api") {
              filelink = ewbConfig.appDomain + list.link.replace(/\\\//g, "/");
              if (list.pagelink !== undefined && list.pagelink !== "") {
                filelink = list.pagelink;
              }
            } else {
              filelink = list.link;
            }

            return (
              <Fragment key={list.title}>
                <a
                  style={{ textDecoration: "none" }}
                  href={filelink}
                  target={
                    list.target == "new" || datasource == "api" ? "_blank" : ""
                  }
                >
                  <ListItem
                    button
                    key={list.title}
                    style={{ paddingLeft: "0px" }}
                  >
                    {list.icon !== undefined && list.icon !== "" ? (
                      <div dangerouslySetInnerHTML={{ __html: list.icon }} />
                    ) : (
                      <i class="fas fa-file-download icon-secondary icon24" />
                    )}

                    <ListItemText
                      style={{ padding: "0 16px" }}
                      primary={
                        <span
                          dangerouslySetInnerHTML={{ __html: list.title }}
                        />
                      }
                    />
                  </ListItem>
                  <Divider />
                </a>
              </Fragment>
            );
          })}
        </List>
      </div>
    </div>
  );
});

const FormatYear = ({ days }) => {
  let date = "";
  if (days > 360) {
    date = days / 360 + " years";
    return (
      <Typography variant="h5" gutterBottom align="center">
        {date}
      </Typography>
    );
  } else {
    date = days + " days";
    return (
      <Typography variant="h5" gutterBottom align="center">
        {date}
      </Typography>
    );
  }
};

const InvestmentProductContents = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: false,
        expandedText: "SHOW PRODUCT FEATURES",
        expandedContactUs: false,
      };
    }

    handleExpandClick = () => {
      this.setState({
        expanded: !this.state.expanded,
      });

      if (this.state.expanded != false) {
        this.setState({
          expandedText: "SHOW PRODUCT FEATURES",
        });
      } else {
        this.setState({
          expandedText: "HIDE PRODUCT FEATURES",
          expandedContactUs: false,
        });
      }
    };

    handleClickOpen = () => {
      this.setState({ open: true });
    };

    handleClose = () => {
      this.setState({ open: false });
    };

    render() {
      const { classes, productname, description, img, copy, note, page } =
        this.props;
      console.log(page);
      return (
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Grid container spacing={2} style={{ flexWrap: "wrap-reverse" }}>
              <Grid item xs={12} sm={12} md container>
                <Grid item xs container direction="column">
                  <Grid item xs>
                    <Typography
                      variant="h6"
                      color="primary"
                      gutterBottom
                      className="fontBold"
                      dangerouslySetInnerHTML={{ __html: productname }}
                    />
                    <Typography
                      variant="body1"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={4}>
                <img src={img} alt={productname} className="img-responsive" />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions className={classes.actions} disableActionSpacing>
            {page === "Fixed Income Products" ? (
              <Link
                to="/request-for-callback/investment"
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  className="buttons trackme"
                >
                  REQUEST FOR CALLBACK
                </Button>
              </Link>
            ) : (
              <Button
                color="secondary"
                variant="contained"
                size="medium"
                className="buttons"
                onClick={this.handleClickOpen}
              // aria-expanded={this.state.expandedContactUs}
              >
                Contact Us
              </Button>
            )}

            {copy !== "" && copy !== undefined ? (
              <Button
                color="secondary"
                variant="outlined"
                size="medium"
                className="buttons"
                onClick={this.handleExpandClick}
                aria-expanded={this.state.expanded}
              >
                {this.state.expandedText}
              </Button>
            ) : (
              ""
            )}
          </CardActions>

          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography
                gutterBottom
                variant="body1"
                dangerouslySetInnerHTML={{ __html: copy }}
              />
              {note !== "" || note !== undefined ? (
                <Typography
                  gutterBottom
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: note }}
                />
              ) : (
                ""
              )}
            </CardContent>
          </Collapse>

          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle
              id="form-dialog-title"
              className={classnames(
                `${page === "Unit Investment Trust Fund"
                  ? classes.uitfBG
                  : classes.trustBG
                }`,
                classes.bold
              )}
              disableTypography={true}
            >
              <Typography color="primary" variant="h5">
                CONTACT US
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Table>
                <TableRow>
                  <TableCell>Unit</TableCell>
                  <TableCell>Contact Number</TableCell>
                  <TableCell>Email Address</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Trust Marketing</TableCell>
                  <TableCell>
                    <a href="tel:+63285753020"> (632) 8575-3020 </a>
                    <br />
                  </TableCell>
                  <TableCell>
                    <a href="mailto:trustMarketing@eastwestbanker.com">
                      TrustMarketing@eastwestbanker.com
                    </a>
                  </TableCell>
                </TableRow>
              </Table>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="secondary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      );
    }
  }
);

const RenderEmployeeProfile = withStyles(styles)(function ({
  name,
  img,
  rank,
  info,
  classes,
}) {
  return (
    <div className={classes.brokerInfo}>
      <Grid container item spacing={2} alignItems="center" justify="center">
        <Hidden smDown>
          <Grid item xs={12} sm={2} />
        </Hidden>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h6"
            color="primary"
            dangerouslySetInnerHTML={{ __html: name }}
          />
          <Typography
            variant="h6"
            color="secondary"
            dangerouslySetInnerHTML={{ __html: rank }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <img
            alt="EastWest Bank broker info"
            src={img}
            className="img-responsive"
          />
        </Grid>
      </Grid>
      <br />
      <Typography variant="body1" dangerouslySetInnerHTML={{ __html: info }} />
      <hr />
    </div>
  );
});

const PromoBanner = withStyles(styles, {
  withTheme: true,
})(
  class extends Component {
    render() {
      const { classes, carouselContents, header, fontColor } = this.props;
      return (
        <div className={classes.spacer}>
          {carouselContents.map((carouselContent) => {
            return (
              <article
                className={classes.carouselStyling}
                key={carouselContent.headline}
              >
                <Grid container>
                  <Grid
                    className={classnames(classes.carouselAligner)}
                    container
                    item
                    sm={12}
                    lg={6}
                  >
                    <Grid item className="gridContainerHalf">
                      <Grid item xs={12} className={classes.carouselText}>
                        <section>
                          <Typography
                            variant="h5"
                            color="primary"
                            gutterBottom
                            align="left"
                            style={{ fontWeight: "600" }}
                          >
                            {carouselContent.headline}
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            align="left"
                            dangerouslySetInnerHTML={{
                              __html: carouselContent.body,
                            }}
                          />
                          <br />
                          <Button
                            component={Link}
                            to={carouselContent.link}
                            size="large"
                            variant="contained"
                            color="secondary"
                          >
                            {carouselContent.cta}
                          </Button>
                        </section>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6} style={{ width: "100%" }}>
                    <CardMedia
                      className={classes.cover}
                      image={carouselContent.image}
                      title={carouselContent.headline}
                    />
                  </Grid>
                </Grid>
              </article>
            );
          })}
        </div>
      );
    }
  }
);

const SingleSliderExplore = withStyles(styles, {
  withTheme: true,
})(
  class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        mText: window.innerWidth <= 370 ? 0 : 130,
        mTopText: 20,
      };
      this.handleResize = this.handleResize.bind(this);
    }

    handleResize() {
      const windowWidth = window.innerWidth;
      let marginLeft = "0px";
      if (windowWidth >= 1901) {
        marginLeft = "300px";
      } else if (windowWidth <= 1900 && windowWidth >= 1601) {
        marginLeft = "250px";
      } else if (windowWidth <= 1600 && windowWidth >= 1402) {
        marginLeft = "160px";
      } else if (windowWidth <= 1401 && windowWidth >= 600) {
        marginLeft = "100px";
      } else if (window.innerWidth <= 370) {
        marginLeft = "0px";
      } else {
        marginLeft = "0px";
      }
      this.setState({ windowWidth, marginLeft });
    }

    componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.handleResize);
    }
    render() {
      const {
        classes,
        carouselContents,
        header,
        fontColor,
        backColor,
        type,
        addApiConfigToImage = false,
        windowSize,
      } = this.props;

      return (
        <div>
          {carouselContents.map((carouselContent) => {
            return (
              <article
                className={classes.carouselStylingExplore}
                style={{ height: this.state.windowWidth <= 400 ? 285 : 230 }}
                key={carouselContent.title}
              >
                <Grid container>
                  <Grid container item sm={10} lg={6}>
                    <Grid item>
                      <Grid
                        item
                        xs={12}
                        className={classes.carouselText}
                        style={{
                          marginLeft: this.state.marginLeft,
                          marginTop: this.state.mTopText,
                        }}
                      >
                        <Container maxWidth="sm">
                          <section>
                            <Typography
                              variant="h5"
                              color="primary"
                              gutterBottom
                              align="left"
                              style={{ fontWeight: "600", marginLeft: "10px" }}
                            >
                              {carouselContent.title}
                            </Typography>
                            <Grid item xs={10}>
                              <Typography
                                variant="body1"
                                gutterBottom
                                align="left"
                                color="primary"
                                dangerouslySetInnerHTML={{
                                  __html: carouselContent.body,
                                }}
                                style={{ marginLeft: "10px" }}
                              />
                            </Grid>
                            <Button
                              component={Link}
                              to={carouselContent.btn_link}
                              size="medium"
                              variant="contained"
                              color="secondary"
                            >
                              {carouselContent.btn_title}
                            </Button>
                          </section>
                        </Container>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={6} style={{ width: "100%" }}>
                    <CardMedia
                      className={classes.cover}
                      image={ewbConfig.apiUrl + carouselContent.image}
                      title={carouselContent.title}
                      style={{ height: 230 }}
                    />
                  </Grid>
                </Grid>
              </article>
            );
          })}
        </div>
      );
    }
  }
);

const ListicleKiids = withStyles(styles)(function ({
  classes,
  lists,
  header,
  datasource,
}) {
  if (!lists) {
    return <div>Loading</div>;
  }

  return (
    <div className={classnames(classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classnames(classes.paperPadding)}>
        <List component="nav">
          {lists.map((list) => {
            let filelink;
            if (datasource == "api") {
              filelink =
                ewbConfig.appDomain +
                list.field_kiids_pdf_file.replace(/\\\//g, "/");
              if (list.pagelink !== undefined && list.pagelink !== "") {
                filelink = list.pagelink;
              }
            } else {
              filelink = list.field_kiids_pdf_file;
            }

            return (
              <Fragment key={list.title}>
                <a
                  style={{ textDecoration: "none" }}
                  href={filelink}
                  target={
                    list.target == "new" || datasource == "api" ? "_blank" : ""
                  }
                >
                  <ListItem
                    button
                    key={list.title}
                    style={{ paddingLeft: "0px" }}
                  >
                    {list.icon !== undefined && list.icon !== "" ? (
                      <div dangerouslySetInnerHTML={{ __html: list.icon }} />
                    ) : (
                      <i class="fas fa-file-download icon-secondary icon24" />
                    )}

                    <ListItemText
                      style={{ padding: "0 16px" }}
                      primary={
                        <span
                          dangerouslySetInnerHTML={{ __html: list.title }}
                        />
                      }
                    />
                  </ListItem>
                  <Divider />
                </a>
              </Fragment>
            );
          })}
        </List>
      </div>
    </div>
  );
});
const ListicleUsefulInformation = withStyles(styles)(function ({
  classes,
  lists,
  header,
  datasource,
}) {
  if (!lists) {
    return <div>Loading</div>;
  }

  return (
    <div className={classnames(classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" />
      <div className={classnames(classes.paperPadding)}>
        <List component="nav">
          {lists.map((list) => {
            let filelink;

            filelink = ewbConfig.appDomain + list.pdf.replace(/\\\//g, "/");

            return (
              <Fragment key={list.title}>
                <a
                  style={{ textDecoration: "none" }}
                  href={filelink}
                  target="_blank"
                >
                  <ListItem
                    button
                    key={list.title}
                    style={{ paddingLeft: "0px" }}
                  >
                    {list.icon !== undefined && list.icon !== "" ? (
                      <div dangerouslySetInnerHTML={{ __html: list.icon }} />
                    ) : (
                      <i class="fas fa-file-download icon-secondary icon24" />
                    )}

                    <ListItemText
                      style={{ padding: "0 16px" }}
                      primary={
                        <span
                          dangerouslySetInnerHTML={{ __html: list.title }}
                        />
                      }
                    />
                  </ListItem>
                  <Divider />
                </a>
              </Fragment>
            );
          })}
        </List>
      </div>
    </div>
  );
});

const SingleSliderProduct = withStyles(styles, {
  withTheme: true,
})(
  class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        viewAll: 3,
        open: false,
        detail: "",
        title: "",
        leftMargin: "40px",
        size: "",
      };
    }

    updateDimensions = () => {
      this.props.windowSize >= 959
        ? this.setState({ viewAll: 3 })
        : this.setState({ viewAll: 2 });
    };
    componentDidMount() {
      this.props.windowSize <= 959
        ? this.setState({ viewAll: 3 })
        : this.setState({ viewAll: 2 });
      window.addEventListener("resize", this.updateDimensions);
    }
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
      const { solution, classes, header, windowSize } = this.props;

      const handleClickOpen = (detail, title) => {
        this.setState({ open: true, detail: detail, title: title });
      };

      const handleClose = () => {
        this.setState({ open: false });
      };

      let slicedData;

      slicedData = solution.slice(0, this.state.viewAll);

      return (
        <div style={{ padding: "25px", marginTop: -70 }}>
          <div className="gridContainer">
            <div className={classes.paperPadding}>
              <Typography
                variant="h5"
                gutterBottom
                align="center"
                style={{ color: "#542785" }}
              >
                <strong>{header}</strong>
              </Typography>
            </div>
          </div>
          <Grid container spacing={3}>
            {solution
              ? slicedData.map((carouselContent) => {
                return (
                  <>
                    <Grid
                      md={4}
                      xs={10}
                      sm={6}
                      lg={4}
                      style={{ marginBottom: "40px" }}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Card
                        className={classes.rounderBorder}
                        style={{
                          height: "100%",
                          width: "95%",
                          marginLeft: windowSize <= 599 ? "50px" : "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          <CardMedia
                            image={
                              ewbConfig.appDomain +
                              carouselContent.field_feature_image.replace(
                                /\\\//g,
                                "/"
                              )
                            }
                            className="cardImage"
                          />
                          <CardContent
                            className={classes.homeCardHeight}
                            style={{ flex: 1 }}
                          >
                            <Typography
                              gutterBottom
                              variant="body1"
                              color="primary"
                              className="fontBold"
                              dangerouslySetInnerHTML={{
                                __html: carouselContent.title,
                              }}
                            />
                            <Typography
                              variant="body1"
                              gutterBottom
                              dangerouslySetInnerHTML={{
                                __html: carouselContent.field_blurb,
                              }}
                            />
                          </CardContent>
                          <CardActions style={{ alignSelf: "flex-start" }}>
                            {carouselContent.field_more_details ? (
                              <Button
                                variant="outlined"
                                color="secondary"
                                style={{
                                  border: "1px solid",
                                  marginLeft: 9,
                                  marginBottom: 8,
                                }}
                                onClick={() =>
                                  handleClickOpen(
                                    carouselContent.field_more_details,
                                    carouselContent.title
                                  )
                                }
                              >
                                <strong>LEARN MORE</strong>
                              </Button>
                            ) : null}
                          </CardActions>
                        </div>
                      </Card>
                    </Grid>
                  </>
                );
              })
              : null}
          </Grid>
          <center>
            {solution.length <= 3 ? (
              ""
            ) : (
              <Button
                size="large"
                variant="contained"
                color="secondary"
                style={{ border: "3px solid" }}
                onClick={() =>
                  this.state.viewAll >= 4
                    ? this.setState({ viewAll: windowSize <= 959 ? 2 : 3 })
                    : this.setState({ viewAll: solution.length })
                }
              >
                <strong>
                  {this.state.viewAll >= 4
                    ? "HIDE OTHER SERVICES"
                    : "SEE ALL SERVICES"}
                </strong>
              </Button>
            )}
          </center>
          <h1>{this.state.open}</h1>
          <Dialog open={this.state.open} onClose={handleClose}>
            <DialogTitle>{this.state.title}</DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                gutterBottom
                dangerouslySetInnerHTML={{ __html: this.state.detail }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
);

const RenderPaperContentInsurance = withStyles(styles)(function ({
  img,
  headline,
  content,
  fontColor,
}) {
  return (
    <Grid style={{ marginTop: -50 }}>
      <Grid container>
        <div
          className="benefits-icon "
          dangerouslySetInnerHTML={{ __html: img }}
        />
      </Grid>
      <Typography
        dangerouslySetInnerHTML={{ __html: headline }}
        variant="body1"
        color={fontColor}
        className="fontBold"
      />
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{ __html: content }}
        align="justify"
      />
    </Grid>
  );
});

const RenderPaperContentCashManagement = withStyles(styles)(function ({
  img,
  headline,
  content,
  fontColor,
}) {
  return (
    <Grid container direction="column" style={{ marginTop: -50 }}>
      <Grid container>
        <div
          className="benefits-icon "
          dangerouslySetInnerHTML={{ __html: img }}
        />
      </Grid>
      <Typography
        dangerouslySetInnerHTML={{ __html: headline }}
        variant="body1"
        color={fontColor}
        className="fontBold"
      />
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{ __html: content }}
        align="justify"
      />
    </Grid>
  );
});

const RenderBusinessFeatureSection = withStyles(styles)(function ({
  classes,
  header,
  featurecontent,
  align,
  fxRatesUsdToPhp,
  fxRatesCnyToPhp,
  fxRatesCnyToUsd,
}) {
  return (
    <div className={classnames(classes.spacer, classes.paperPadding)}>
      <SectionTitle header={header} fontColor="primary" align={align} />
      <div className={classes.paperPadding}>
        <Grid container spacing={2}>
          {featurecontent.map(function (feature, index) {
            return (
              <Grid
                item
                xs={12}
                sm={12}
                md
                key={index}
                className={classes.cardfeaturesHeight}
              >
                <Card className={classes.rounderBorder}>
                  <CardMedia
                    image={
                      ewbConfig.appDomain + feature.image.replace(/\\\//g, "/")
                    }
                    className="cardImage"
                    style={{ width: "100%" }}
                  />
                  <CardContent
                    className={classes.homeCardHeight}
                    style={{ height: 130 }}
                  >
                    <Typography
                      gutterBottom
                      variant="body1"
                      color="primary"
                      className="fontBold"
                      dangerouslySetInnerHTML={{ __html: feature.title }}
                    />
                    {feature.title == "FX Rates" ? (
                      <table style={{ borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            <th
                              style={{
                                borderBottom: "1px solid black",
                                paddingLeft: 1,
                              }}
                            ></th>
                            <th
                              style={{
                                borderBottom: "1px solid black",
                                paddingLeft: 18,
                              }}
                            >
                              Buy
                            </th>
                            <th
                              style={{
                                borderBottom: "1px solid black",
                                paddingLeft: 7,
                              }}
                            >
                              Sell
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                paddingLeft: 15,
                                paddingRight: 25,
                                fontSize: 15,
                              }}
                            >
                              USD/PHP
                            </td>
                            <td
                              style={{
                                paddingLeft: 40,
                                paddingRight: 25,
                                fontSize: 15,
                              }}
                            >
                              {fxRatesUsdToPhp.buyRate}
                            </td>
                            <td
                              style={{
                                paddingLeft: 40,
                                paddingRight: 25,
                                fontSize: 15,
                              }}
                            >
                              {fxRatesUsdToPhp.sellRate}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingLeft: 15, fontSize: 15 }}>
                              CNY/PHP
                            </td>
                            <td style={{ paddingLeft: 40, fontSize: 15 }}>
                              {fxRatesCnyToPhp.buyRate}
                            </td>
                            <td style={{ paddingLeft: 40, fontSize: 15 }}>
                              {fxRatesCnyToPhp.sellRate}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingLeft: 15, fontSize: 15 }}>
                              CNY/USD
                            </td>
                            <td style={{ paddingLeft: 40, fontSize: 15 }}>
                              {fxRatesCnyToUsd.buyRate}
                            </td>
                            <td style={{ paddingLeft: 40, fontSize: 15 }}>
                              {fxRatesCnyToUsd.sellRate}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <Typography
                        variant="body1"
                        gutterBottom
                        dangerouslySetInnerHTML={{ __html: feature.body }}
                      />
                    )}
                  </CardContent>
                  <CardActions>
                    {feature.field_link_type === "External" ? (
                      <Button
                        href={feature.btn_link}
                        size="small"
                        variant="contained"
                        color="secondary"
                        className={classes.promoButton}
                      >
                        {feature.btn_title}
                      </Button>
                    ) : (
                      <Button
                        component={Link}
                        to={feature.btn_link}
                        size="small"
                        variant="contained"
                        color="secondary"
                        className={classes.promoButton}
                      >
                        {feature.btn_title}
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
});

export {
  FormatYear,
  SectionTitle,
  RenderModalButton,
  RenderHeaderSection,
  RenderPromoHeaderSection,
  RenderPaperContent,
  CashBenefitsSection,
  CashRenderBenefitFeatures,
  RenderBenefitFeatures,
  RenderPromoSection,
  RenderPromoSectionCMS,
  RenderHelpSection,
  RenderPageBanner,
  RenderExpansionContent,
  SingleSlider,
  SamplePrevArrow,
  MultipleSlider,
  MultipleItemSlider,
  MultipleSliderV1,
  RenderPromoCard,
  NavAffix,
  FAQExpansion,
  RenderSupportHeader,
  SupportQuickLinks,
  PromoQuickLinks,
  SearchBar,
  DialogWindow,
  RenderExpansionContentTable,
  CardServices,
  PromosSection,
  BenefitsSection,
  CardServicesMobile,
  FeesAndChargesWeb,
  RenderApplicationSteps,
  FeesAndChargesMobile,
  InvestmentProductContents,
  Listicle,
  ListicleKiids,
  FeaturesSection,
  RenderEmployeeProfile,
  MultipleSliderAbout,
  RenderExpansionCardContent,
  RenderFeatureSection,
  RenderProducts,
  PromoCardBox,
  PromoBanner,
  SingleSliderExplore,
  BenefitsSectionCashManagement,
  SingleSliderProduct,
  RenderBusinessFeatureSection,
  ListicleUsefulInformation,
  RenderPageCompleteBanner,
  RenderHeaderCompleteSection,
  RenderHeaderInsuranceSection,
  BenefitsSectionInsurance,
};
